module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reminders-meeting"
  }, [(_vm.displayMode === 'monthly') ? _c('div', [_c('div', [_c('el-date-picker', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "month",
      "size": "mini",
      "clearable": false
    },
    on: {
      "change": _vm.handleDateChange
    },
    model: {
      value: (_vm.date.monthly),
      callback: function($$v) {
        _vm.$set(_vm.date, "monthly", $$v)
      },
      expression: "date.monthly"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "header-title m-t-0 m-b-20"
  }, [_vm._v("Rendez-vous téléphoniques du mois")])], 1), _vm._v(" "), _c('month-timetable', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "events": _vm.events,
      "month": _vm.date.monthly
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('span', {
          staticClass: "vue-timetable-event-color",
          style: ({
            backgroundColor: props.event.color
          })
        }), _vm._v(" "), _c('span', {
          staticClass: "vue-timetable-event-link"
        }, [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": props.event.title + ' ' + (props.event.meta.reminder.description ? ' : ' + props.event.meta.reminder.description : ''),
            "placement": "top"
          }
        }, [_c('div', [_c('span', {
          directives: [{
            name: "edit",
            rawName: "v-edit:reminder",
            value: (props.event.meta.reminder),
            expression: "props.event.meta.reminder",
            arg: "reminder"
          }],
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_c('span', {
          staticClass: "vue-timetable-event-time"
        }, [_vm._v(_vm._s(_vm._f("moment")(props.event.date.from, 'HH:mm')) + " - " + _vm._s(_vm._f("moment")(props.event.date.to, 'HH:mm')))])]), _vm._v(" "), (_vm.models.customers.find(function (customer) { return customer.id === props.event.meta.reminder.customer_id; })) ? _c('div', [_c('router-link', {
          attrs: {
            "to": '/customers/' + props.event.meta.reminder.customer_id
          }
        }, [_c('customer', {
          attrs: {
            "item": _vm.models.customers.find(function (customer) { return customer.id === props.event.meta.reminder.customer_id; }),
            "present": "name"
          }
        })], 1)], 1) : _c('div', [_vm._v("\n                " + _vm._s(props.event.description) + "\n              ")])])])], 1)]
      }
    }], null, false, 2980472452)
  })], 1) : _vm._e(), _vm._v(" "), (_vm.displayMode === 'weekly') ? _c('div', [_c('div', [_c('el-date-picker', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "type": "week",
      "size": "mini"
    },
    on: {
      "change": _vm.handleDateChange
    },
    model: {
      value: (_vm.date.weekly),
      callback: function($$v) {
        _vm.$set(_vm.date, "weekly", $$v)
      },
      expression: "date.weekly"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "header-title m-t-0 m-b-20"
  }, [_vm._v("Rendez-vous téléphoniques de la semaine")])], 1), _vm._v(" "), _c('week-timetable', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "events": _vm.events,
      "cell-height": 75,
      "week": _vm.date.weekly,
      "hour-range": {
        start: 8,
        end: 19
      },
      "day-range": [1, 2, 3, 4, 5]
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": props.event.title + ' ' + (props.event.meta.reminder.description ? ' : ' + props.event.meta.reminder.description : ''),
            "placement": "top"
          }
        }, [_c('div', {
          staticStyle: {
            "font-size": "0.9em",
            "text-align": "center",
            "width": "100%",
            "height": "100%"
          }
        }, [_c('div', {
          directives: [{
            name: "edit",
            rawName: "v-edit:reminder",
            value: (props.event.meta.reminder),
            expression: "props.event.meta.reminder",
            arg: "reminder"
          }],
          staticClass: "edit-button",
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_c('div', [_c('i', {
          staticClass: "fa fa-pencil"
        })])]), _vm._v(" "), (_vm.models.customers.find(function (customer) { return customer.id === props.event.meta.reminder.customer_id; })) ? _c('div', [_c('router-link', {
          staticStyle: {
            "color": "white"
          },
          attrs: {
            "to": '/customers/' + props.event.meta.reminder.customer_id
          }
        }, [_c('div', [_c('strong', [_vm._v(_vm._s(_vm._f("moment")(props.event.date.from, 'HH:mm')) + " - " + _vm._s(_vm._f("moment")(props.event.date.to, 'HH:mm')))])]), _vm._v(" "), _c('customer', {
          attrs: {
            "item": _vm.models.customers.find(function (customer) { return customer.id === props.event.meta.reminder.customer_id; }),
            "present": "name"
          }
        })], 1)], 1) : _c('div', [_c('div', [_c('strong', [_vm._v(_vm._s(_vm._f("moment")(props.event.date.from, 'HH:mm')) + " - " + _vm._s(_vm._f("moment")(props.event.date.to, 'HH:mm')))])]), _vm._v("\n              " + _vm._s(props.event.description) + "\n            ")])])])]
      }
    }], null, false, 662281969)
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0658e276"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents/Main/Reminders/RemindersMeetingsList.vue
// module id = 659
// module chunks = 1